<template>
    <div >
        <div class="level is-vcentered">
            <div class="level-item has-text-centered">
                <h1 class="title is-size-4">Request Password Change</h1>
            </div>
        </div>
        <form @submit.prevent="requestPasswordChange">
        <div class='password-change-container box'>
            <section>
                <b-notification type="is-danger" v-if="errorMessage" :closable="false">
                    {{ errorMessage }}
                </b-notification>
                <b-field label="Email" class="is-extra-wide" horizontal>
                    <input class="input has-icons-right" type="email" v-model="email" placeholder="Please enter your email" required/>
                </b-field>

                <b-field horizontal><!-- Label left empty for spacing -->
                    <button type="submit" class="button is-primary" :disabled="isSaving">
                        Request Password Change
                        <i v-if="isSaving" class="fas fa-spinner fa-spin is-small"></i>
                    </button>
                </b-field>
                <b-notification type="is-success" v-if="isRequestMade" :closable="false">
                    Your password change request has been accepted, please check your email for instructions.
                </b-notification>
            </section>
        </div>
        </form>
    </div>
</template>

<script>
import PasswordChangeService from '@/services/password-change-service.js';
export default {
    name: 'ForgottenPassword',
    data () {
        return {
            email: '',
            errorMessage: '',
            isSaving: false,
            isRequestMade: false
        };
    },
    methods: {
        requestPasswordChange () {
            let requestPasswordChangeBody = {
                userEmail: this.email
            };

            this.errorMessage = '';
            this.isSaving = true;
            PasswordChangeService.requestPasswordChange(requestPasswordChangeBody)
                .then(
                    response => {
                        this.isRequestMade = true;
                    }
                ).catch(
                    error => {
                        if (error.response && error.response.data) {
                            this.errorMessage = error.response.data.message;
                        } else {
                            this.errorMessage = error.message;
                        }
                    }
                ).finally(
                    () => {
                        this.isSaving = false;
                    }
                );
        }
    }
};
</script>

<style lang="scss" scoped>
.password-change-container{
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
}
</style>
